import {
  ArticlePage,
  BlogPage,
  Error404Page,
  MainPage,
  EditorialPage,
  CaseStudiesPage,
  AboutUsPage,
  ServicesPage,
  KnowledgePage,
  JoinUsPage,
  PrivacyPage,
  TestingPage,
  AuditsPage,
  AutomationPage,
  BusinessPage,
  ConsultingPage,
  ContactPage,
  CoursesPage,
  CybersecurityPage,
  DevelopmentContractingPage,
  CaseStudyPage,
  EbookPage,
  WebinarPage,
  ThankYouPage,
  // Error500Page,
  ArticlePreviewPage,
  OfferPage,
  KSCAuditsPage,
  NewPentestsPage,
  SocialEngineeringTestsPage,
  AuditsItPage,
  BlackBoxTestingPage,
  PenetrationTestsPage,
  PentestsPage,
  CypherdogPage,
  ZeroTrustArchitecturePage,
  PerformanceTestingPage
} from 'pages';

import { RouteProps } from 'react-router-dom';
import { CustomArticleSlugTypes } from 'types/global';

export const customPages: CustomArticleSlugTypes[] = [
  'main',
  'privacy',
  'contact',
  'not_found',
  'case_studies',
  'about_us',
  'join_us',
  'services',
  'knowledge',
  'business',
  'privacy',
];

export interface ExtendedRoute extends RouteProps {
  withSidebar?: boolean;
}

export const routes: ExtendedRoute[] = [
  {
    path: 'main',
    component: MainPage,
  },
  {
    path: 'case_studies',
    component: CaseStudiesPage,
  },
  {
    path: 'contact',
    component: ContactPage,
  },
  {
    path: 'about_us',
    component: AboutUsPage,
  },
  {
    path: 'business',
    component: BusinessPage,
  },
  {
    path: 'services',
    component: ServicesPage,
  },
  {
    path: 'services/testing',
    component: TestingPage,
  },
  {
    path: 'services/cybersecurity',
    component: CybersecurityPage,
  },
  {
    path: 'services/social_engineering_tests',
    component: SocialEngineeringTestsPage,
  },
  {
    path: 'services/audits_it',
    component: AuditsItPage,
  },
  {
    path: 'services/pen_tests',
    component: NewPentestsPage,
  },
  {
    path: 'services/automation',
    component: AutomationPage,
  },
  {
    path: 'services/audits',
    component: AuditsPage,
  },
  {
    path: 'services/courses',
    component: CoursesPage,
  },
  {
    path: 'services/consulting',
    component: ConsultingPage,
  },
  {
    path: 'services/pentests',
    component: PentestsPage,
  },
  {
    path: 'services/black_box_testing',
    component: BlackBoxTestingPage,
  },
  {
    path: 'services/development_contracting',
    component: DevelopmentContractingPage,
  },
  {
    path: 'services/ksc_audits',
    component: KSCAuditsPage,
  },
  {
    path: 'services/penetration_tests',
    component: PenetrationTestsPage,
  },
  {
    path: 'services/performance_testing',
    component: PerformanceTestingPage,
  },
  {
    path: 'services/zero-trust-architecture',
    component: ZeroTrustArchitecturePage,
  },
  {
    path: 'cypherdog',
    component: CypherdogPage,
  },
  {
    path: 'knowledge',
    component: KnowledgePage,
  },
  {
    path: 'join_us',
    component: JoinUsPage,
  },
  {
    path: 'join_us/:offerId',
    component: OfferPage,
  },
  {
    path: 'privacy',
    component: PrivacyPage,
  },
  {
    path: 'blog',
    component: BlogPage,
  },
  {
    path: 'blog/:articleId',
    component: ArticlePage,
  },
  {
    path: 'preview/:parentId/:revision/:preview',
    component: ArticlePreviewPage,
  },
  {
    path: 'webinars/:articleId',
    component: WebinarPage,
  },
  {
    path: 'ebooks/:articleId',
    component: EbookPage,
  },
  {
    path: 'case_studies/:articleId',
    component: CaseStudyPage,
  },
  // {
  //   path: 'error',
  //   component: Error500Page,
  // },
  {
    path: 'thank_you',
    component: ThankYouPage,
  },
  {
    path: 'not_found',
    component: Error404Page,
  },
  {
    path: ':pageId',
    component: EditorialPage,
  },
];

export default routes;
